var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-list"},_vm._l((_vm.tagList),function(item,index){return _c('span',{key:index,staticClass:"tag-item"},[_vm._v(_vm._s(item.name))])}))}
var staticRenderFns = []

export { render, staticRenderFns }